import styled from 'styled-components';
import PodUpload from './PodUpload';
import { colorSchema } from 'utils/style';

export default styled(PodUpload)`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 50%;
  padding-right: 1.6rem;

  &:nth-child(even),
  &:last-of-type {
    padding-right: 0;
  }

  .pod-upload {
    display: flex;
    flex-direction: column;
    margin: 2.4rem 0;

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: bold;
      line-height: 1.19;
      margin-bottom: 1.6rem;
    }

    &__droparea {
      align-items: center;
      background-color: ${colorSchema('grey100')};
      border-radius: 4px;
      border: 1px dashed ${colorSchema('grey700')};
      display: flex;
      flex-direction: column;
      height: 81px;
      margin-bottom: 2.4rem;
      padding: 1.6rem 0;

      &--disabled {
        opacity: 0.5;
      }

      &--accept {
        background-color: ${colorSchema('primary200')};
      }
    }

    &__drop-help {
      color: ${colorSchema('grey900')};
      margin-bottom: 0.8rem;
    }

    &__drop-button {
      background: none;
      border: 0;
      color: ${colorSchema('primary')};
      cursor: pointer;
      font-weight: bold;

      &:hover {
        text-decoration: underline;
      }
    }

    &__file-container {
      display: flex;
      flex-direction: column;
    }

    &__file-info {
      display: flex;
    }

    &__file {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }

    &__file-name {
      color: ${colorSchema('grey800')};
      font-size: 1.6rem;

      &--error {
        color: ${colorSchema('error900')};
      }
    }

    &__error-label {
      color: ${colorSchema('error900')};
      font-size: 1.4rem;
    }

    &__error-container {
      border-radius: 4px;
      border: 1px solid ${colorSchema('error900')};
      background: ${colorSchema('error100')};
      padding: 0.8rem 1.6rem;
      margin: 0.8rem 0;
    }

    &__error-text {
      color: ${colorSchema('grey900')};
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 1.43;
    }

    &__file-delete {
      background: none;
      border: 0;
      cursor: pointer;
      svg {
        fill: ${colorSchema('grey500')};
      }
    }
  }
`;
